module.exports = __webpack_public_path__ + "static/terra-mattress-slower-6349a5bf898f884c8995b7ca2cd92510.mp4";